import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupLocation } from '../Types';

const RESOURCE = 'locations';

interface IUpdateGroupLocation extends Omit<IUri, 'resource'> {
  id: string;
  body: Partial<IGroupLocation>;
  token: string;
}

interface IUpdateGroupLocationResponse extends IHttpResponse {
  body?: IGroupLocation;
}

export default ({
  id,
  body,
  token,
}: IUpdateGroupLocation): Promise<IUpdateGroupLocationResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    id,
  });

  return BaseService.Patch({ url, token, data: body });
};
